module.exports = __webpack_public_path__ + "assets/img/ph_donation_list.e1792c3a.svg";